<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <g transform="translate(-165.208 -309.329)">
     <path d="M178.995,312.396h-7.147c-0.984,0.003-1.78,0.803-1.778,1.787l-0.009,14.294c-0.002,0.984,0.794,1.784,1.778,1.787h10.73
      c0.986-0.003,1.784-0.801,1.787-1.787v-10.721L178.995,312.396z M171.848,328.477v-14.294h6.254v4.467h4.467v9.827H171.848z"/>
    </g>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'resource'
}
</script>
